import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const from = loc.state?.from || "/";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) {
      toast.success(`Welcome back, ${r.user.name.split(" ")[0]}.`);
      nav(r.user.role === "admin" ? "/admin" : from, { replace: true });
    } else {
      toast.error(r.error);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-[80vh] grid lg:grid-cols-2">
      <section className="hidden lg:block bg-[#ff1493] border-r-[3px] border-black relative overflow-hidden">
        <div className="hex-grid absolute inset-0 opacity-20" />
        <div className="relative h-full flex flex-col justify-between p-12 text-white">
          <div className="font-mono-ui text-[11px]">— MEMBERS AREA</div>
          <div>
            <h2 className="font-display text-5xl leading-none">Sign in to track<br />your research orders.</h2>
            <p className="mt-5 font-mono-ui text-xs max-w-sm">Lot numbers, assay certificates, dispatch tracking &mdash; all in one place.</p>
          </div>
          <div className="font-mono-ui text-[11px]">UK PEPTIDE RESEARCH · EST. 2024</div>
        </div>
      </section>

      <section className="flex items-center justify-center p-6 md:p-12">
        <form onSubmit={submit} className="w-full max-w-md border-[3px] border-black bg-white p-8 shadow-brut space-y-4">
          <div className="font-mono-ui text-xs text-[#ff1493]">— SIGN IN</div>
          <h1 className="font-display text-4xl leading-none">Welcome back.</h1>

          <div>
            <label className="font-mono-ui text-[10px] block mb-1">EMAIL</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="w-full border-[3px] border-black px-3 py-2 font-mono-ui text-xs" />
          </div>
          <div>
            <label className="font-mono-ui text-[10px] block mb-1">PASSWORD</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="w-full border-[3px] border-black px-3 py-2 font-mono-ui text-xs" />
          </div>

          <button type="submit" disabled={loading} data-testid="login-submit" className="w-full py-3 bg-[#ff1493] text-white border-[3px] border-black shadow-brut btn-press font-mono-ui text-xs font-bold disabled:opacity-60">
            {loading ? "SIGNING IN…" : "SIGN IN"}
          </button>

          <div className="font-mono-ui text-[11px] text-black/70 pt-2">
            No account? <Link to="/register" className="underline hover:text-[#ff1493]">Create one</Link>
          </div>
        </form>
      </section>
    </div>
  );
}
